<template>
  <div>
    <el-card class="box-card" v-if="parentdata.operationtype == 123">
      <ul>
        <li>1. 退货&供应商：如果需要退货给供应商，那么就录入负数</li>
        <li>2. 退货入账&供应商：如果供应商把之前退的货再交付过来，那么就录入正数</li>
        <li>3. 换货&供应商：如果与供应商之间发生换货，那么就录入0，然后在备注里面写入详情情况</li>
      </ul>
    </el-card>
    <el-card class="box-card" v-if="parentdata.operationtype == 456">
      <ul>
        <li>1. 出库&客户：如果需要出库给客户，那么就录入正数</li>
        <li>2. 退货&客户：如果客户退货回来，那么就录入负数</li>
        <li>3. 换货&客户：如果与客户之间发生换货，那么就录入0，然后在备注里面写入详情情况</li>
      </ul>
    </el-card>
    <el-card class="box-card">
      <div class="title mt20">{{title}}</div>
      <el-form :model="postData" ref="postDataRef" label-width="82px">
        <el-form-item label="领用部门" v-if="parentdata.operationtype == 456" class="addAdminForm">
          <RsljigouInternal :propsjigouid="postData.jigouid" :propsjigouname="postData.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
        </el-form-item>
        <el-form-item label="数量" class="addAdminForm">
          <el-input v-model="postData.operationnum" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="postData.beizhu" placeholder=""></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">添加</el-button>
          <el-button type="info" @click="backCustomerManagement">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">历史记录</div>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Jigouname" label="领用部门"></el-table-column>
        <el-table-column prop="Operationnum" label="数量"></el-table-column>
        <el-table-column prop="Beizhu" label="备注"></el-table-column>
        <el-table-column prop="Adminname" label="操作人员"></el-table-column>
        <el-table-column prop="Createtime" label="操作时间"></el-table-column>
        <el-table-column prop="operation" label="操作" min-width="20%">
          <template v-slot="scope">
          <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_MadeManagement_Delete" @click="clickdelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  data () {
    return {
      title: '库存操作',
      postData: {
        jigouid: '0',
        jigouname: '',
        operationnum: '',
        beizhu: ''
      },
      listlog: [],
      parentdata: {
        operationtype: 123
      },
      SubRule_MadeManagement_Delete: false
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_Delete = true
      }
    })
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.title = parentdata.name
      this.postData.jigouid = '0'
      this.postData.jigouname = ''
      this.postData.operationnum = ''
      this.postData.beizhu = ''
      this.listlog = []
      this.apigetmadeorderkucun()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    changeRsljigouInternal (vid, vname) {
      this.postData.jigouid = vid
      this.postData.jigouname = vname
    },
    clicksave () {
      this.apiaddmadeorderkucun()
    },
    clickdelete (row) {
      this.$confirm('是否删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteMadeOrderKucun(row.Id)
      })
    },
    apigetmadeorderkucun: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.parentdata.orderid,
        operationtype: that.parentdata.operationtype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getmadeorderkucun, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.listlog = response.data.List
            // response.data.List.filter((item, i) => {
            //   that.listlog.push({ Pausetype: item.Pausetype, Beizhu: item.Beizhu, Adminname: item.Adminname, Createtime: item.Createtime })
            // })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddmadeorderkucun: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.parentdata.orderid,
        bomsn: that.parentdata.bomsn,
        operationnum: that.postData.operationnum,
        operationtype: that.parentdata.operationtype,
        beizhu: that.postData.beizhu,
        jigouiduse: that.postData.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addmadeorderkucun, Qs.stringify(data))
        .then(function (response) {
          that.apigetmadeorderkucun()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DeleteMadeOrderKucun: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteMadeOrderKucun, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apigetmadeorderkucun()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
